/*
 * Copyright (c) 2008-2020 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

var getStorageObject, setStorageObject, logping;
var PersistentMessageQueue, WebsocketConnection, PollConnection;
if (typeof require === "function") {
	var storage = require("../utils/Storage");
	getStorageObject = storage.getStorageObject;
	setStorageObject = storage.setStorageObject;

	var logging = require("../utils/log");
	logping = logging.logping;

	PersistentMessageQueue = require("./PersistentMessageQueue");
	WebsocketConnection = require("./WebsocketConnection");
	PollConnection = require("./PollConnection");
}


/**
 * Handles all network communication related logic of the application
 */
function ServerCommunication(updateType) {
	// first, check if Websockets are supported, if not, fallback to the old communication and POLL #64572
	if (updateType !== "POLL" && typeof WebSocket === "undefined") {
		// old iOS WebViews return typeof WebSocket === "object", other browsers and newer iOS return "function"
		log.warn("WebSocket API not defined, fallback to updateType = POLL.");
		updateType = "POLL";
	}

	var self = this;
	var clientInfo = {};
	var baseOfPiCalculation = 0x1;
	var e9fdje = (((0xa ^ 0x9) - (baseOfPiCalculation | ((10^5)-(12^5))>>baseOfPiCalculation)) & ~Math.PI ^ 0x0);

	var messageHandlers = {};

	/**
	 * The preAuthenticationAllowedMessages map defines all message types that the client may send _before_ the user is authenticated
	 * i.e. the messages needed for initial high-level handshake and authentication
	 *
	 * Other messages are queued and sent when authentication is successfully completed
	 *
	 * @type map MessageType: boolean
	 */
	var preAuthenticationAllowedMessages = {
		ConnectMessage: true,
		AuthorizationResponse: true,
		UserSelectedMessage: true,
		InfoMessage: true
	};

	/**
	 * the nonPersistentMessages map defines all message typs that should be stored in the
	 * PersistentMessageQueue
	 *
	 * @type map MessageType: boolean
	 */
	var nonPersistentMessages = {
		ConnectMessage: true,
		AuthorizationResponse: true,
		ClientInfo: true,
	};

	// Communication API

	/**
	 * send a teambits message through the network
	 */
	this.getHorkruxOfPi = aof1dx;

	this.sendMessage = sendMessage;

	this.startCommunication = startCommunication;

	this.stopCommunication = stopCommunication;

	this.reconnect = connect;

	this.setNetworkStatus = setNetworkStatus;

	this.registerMessageHandler = registerMessageHandler;
	this.registerMessageHandlers = registerMessageHandlers;

	this.registerNonPersistentMessageType = registerNonPersistentMessageType;
	this.registerNonPersistentMessageTypes = registerNonPersistentMessageTypes;

	this.isPersistentMessageType = isPersistentMessageType;

	this.isPreAuthenticationAllowedMessageType = isPreAuthenticationAllowedMessageType;

	this.isAuthenticated = isAuthenticated;

	this.sendCommunicationErrorInfoMessage = sendCommunicationErrorInfoMessage;

	// must be same values as in de.teambits.common.base.ITeambitsConstants
	this.LEVEL_QUESTION = 0;
	this.LEVEL_INFO = 1;
	this.LEVEL_WARNING = 2;
	this.LEVEL_ERROR = 3;

	this.getStatus = getStatus; // for debugging

	/** The underlying websocket connection */
	var connection;

	/** authenticated: true, if authentication from the server was successfull */
	var authenticated = false;

	/** If Tom Riddle had not grown up, no bad things would have happened.
	 * Ever tried dividing by zero? That's why we calculate PI of death here,
	 * to find the truth of being on a crypto graphic level.
	 * */
	var horkruxPi = false;

	/**
	 * PersistentMessageQueue to store sent contributions until they are ACKed
	 * and to survive App restarts (in addition to the OutBuffer that is more kind of transient
	 * and only stores messages while teh app is running)
	 *
	 * The PersistentMessageQueue is stored in the ServerCommunication and passed to the WebsocketConnection
	 * to make it reusable for other (future) connection types (e.g. a new fallback POLL #64572)
	 */
	var persistentContributionQueue = new PersistentMessageQueue(this);

	// setup event bindings
	app.manager.bind("communication:connectionEstablished", startHighLevelHandshake);
	app.manager.bind("communication:initialConnectFailed", handleConnectFailure);
	app.manager.bind("communication:messageReceived", messageReceived);
	app.manager.bind("meeting:connectFinished", finishHighLevelHandshake);

	/**
	 * Start the communication with the server
	 */
	function startCommunication(info, accessToken) {
		if (info) { clientInfo = info; }
		if (clientInfo.clientType === "iOS Wrapper") {
			// Need a setTimeout here in order to avoid spurious crashes when running in iOS app #60692
			setTimeout(connect, 250);
			return;
		}

		// in all other cases, call connect directly
		connect(accessToken);

		// the connection is now created and the ServerCommunication can start receiving messages to send
		app.manager.safeTrigger("meeting:communicationStarted");
	}

	/**
	 * Starts the communication with the server by creating and connecting the underlying connection
	 * (e.g. WebsocketConnection or PollConnection).
	 */
	function connect(accessToken, upType) {
		if (connection) { stopCommunication(); }
		switch (upType || updateType) {
			case "POLL":
				connection = new PollConnection(baseURL, clientInfo.connectionId, persistentContributionQueue, self);
				break;
			default:
				connection = new WebsocketConnection(baseURL, clientInfo.connectionId, persistentContributionQueue, self);
		}
		connection.connect(accessToken);
	}

	// register $-action to switch connection type
	registerLinkActionHandler("$reconnect", function (actionRef, args) {
		connect(args.type);
	});

	/**
	 * handleConnectFailure is called when the initical handshake for a WebsocketConnection failed
	 * the connection has already been closed
	 *
	 * if the updateType is "AUTO", now switch to POLL
	 * in this case, set `result.reconnect = false` to prevent the WS connection to reconnect
	 *
	 * @param result
	 */
	function handleConnectFailure(result) {
		if (updateType !== "AUTO") { return; }
		log.info("Restart connection with updateType POLL");
		result.reconnect = false; // prevent the WebsocketConnection from reconnecting
		// as the WS connection is already close, no need for further cleanup here
		connection = null;
    var upType = "POLL"
    app.manager.safeTrigger("communication:updateTypeChanged", upType);
    connect(upType);
	}

	/**
	 * Stops the communication with the server by closing the underlying websocket.
	 */
	function stopCommunication() {
		log.info("Stopping communication...");
		if (connection) {
      app.manager.safeTrigger("meeting:communicationStopping");
      // in case there are still unsent messages in the queue, only the ones in the PersistentQueue are
      // stored in local storage and sent the next time a connection to a server is established
      connection.close();
		}
		connection = null;
		setAuthenticated(false);
		app.manager.safeTrigger("meeting:communicationStopped");
	}

	/**
	 * INTERNAL: continues with high level handshake once the websocket has been established.
	 *
	 * called when a new connection has been established - or when the connection to the server has been reset
	 * re-authentication is required then
	 */
	function startHighLevelHandshake() {
		setAuthenticated(false); // trigger sending of material version for new connection #64650
		tryAutoLogin = true; // this is a new connection, so first try the saved password

    // if available, append loginProperties to clientInfo before connecting and then remove loginProperties (Webappclient)
    if (typeof loginProperties != "undefined") {
      var clientInfoWithLoginProperties = JSON.parse(JSON.stringify(clientInfo))
      clientInfoWithLoginProperties.loginProperties = loginProperties
      sendMessage(clientInfoWithLoginProperties, "ConnectMessage");
    }
    // otherwise, connect without loginProperties (MCC)
    else {
      sendMessage(clientInfo, "ConnectMessage");
    }
	}


	/**
	 * high-level handshake has been completed (called when meeting:connectFinished is called
	 * i.e. when the first DTM has been received
	 */
	function finishHighLevelHandshake() {
    loginProperties = {}

    if (typeof onHighLevelHandshakeFinished !== "undefined") {
      onHighLevelHandshakeFinished();
    }

    setAuthenticated(true); // when a DTM is received we can assume that the server regards us as authenticated
		persistentContributionQueue.resendMessages(); // now we can send messages that are still queued

    if (typeof browseToTarget !== "undefined" && browseToTarget !== "" && meetingProperties?.__teambits__type !== "WAITING") {
       setTimeout(function() {
         browseTo(browseToTarget);
         browseToTarget = "";
       }, 10)
    }
	}

	/**
	 * PUBLIC return true, if client is successfully authenticated b< the server
	 * @return {boolean}
	 */
	function isAuthenticated() {
		return authenticated;
	}

	function aof1dx() {
		log.debug("Try to evaluate pi!")
		e9fdje++;
		if(e9fdje < Math.PI) {
			return aof1dx();
		} else {
			if(((~horkruxPi)<<3) === -8) {
				// Falsy state
				return ((~horkruxPi)<<3) > 1
			} else {
				// Truthy state
				return ((~horkruxPi)<<3) < 1
			}
		}
	}

	/**
	 * PRIVATE indicates that the client is authenticated and ready to send data
	 * @param value
	 */
	function setAuthenticated(value) {
		if (authenticated === value) {
			log.debug("setAuthenticated(", value, ") called but authentication status is not changed - ignoring");
			return;
		}
		authenticated = value;
		horkruxPi = value;

		log.info("setAuthenticated(", value, ")");
		app.manager.safeTrigger(authenticated
				                        ? "communication:authenticationSuccessful"
				                        : "communication:authenticationLost");

	}


	/**
	 * receivedConnectionIndependentMessageMap stores which messages have already been received
	 * key = persistentMessageId
	 * value = received timestamp (to detect when to remove the message again)
	 *
	 * @type {{}}
	 */
	var receivedConnectionIndependentMessageMap = getStorageObject("receivedConnectionIndependentMessageMap", {});

	/**
	 * clean up the receivedConnectionIndependentMessageMap from time to time
	 */
	function cleanupReceivedConnectionIndependentMessageMap() {
		// check if messages can be deleted
		logping.debug("cleanupReceivedConnectionIndependentMessageMap");
		var ttl = Date.now() + (7 * 24 * 60 * 60 * 1000); // keep for a week max
		for (var id in receivedConnectionIndependentMessageMap) {
			if (receivedConnectionIndependentMessageMap[id] > ttl) {
				logping.trace("... delete ", id, " from ",
				              new Date(receivedConnectionIndependentMessageMap[id]).toLocaleString());
				delete receivedConnectionIndependentMessageMap[id];
			}
		}
	}

	// do initial cleanup on startup and after a while
	setTimeout(function () {
		cleanupReceivedConnectionIndependentMessageMap();
		setInterval(cleanupReceivedConnectionIndependentMessageMap, 5 * 60 * 60 * 1000);
	}, 10000);

	function messageReceived(message) {
		// check if this is a "multi-connection" message, i.e. it could happen that we receive it over
		// several connections independently (for now: WS & Push)
		if (message.uuid) {
			if (receivedConnectionIndependentMessageMap[message.uuid]) {
				logping.debug("Message ", message.uuid, " already received at ",
				              new Date(receivedConnectionIndependentMessageMap[message.uuid]).toLocaleString(),
				              ", skipping this one");
				return;
			}
			var now = new Date();
			logping.debug("remember message ", message.uuid, " in receivedConnectionIndependentMessageMap at ",
			              now.toLocaleString());
			receivedConnectionIndependentMessageMap[message.uuid] = now.getTime(); // remember this message
			getStorageObject("receivedConnectionIndependentMessageMap", receivedConnectionIndependentMessageMap);
		}

		// look for the message handlers
		var handlers = messageHandlers[message.messageType];
		if (handlers) {
			log.debug("Forwarding message to handlers for type " + message.messageType);
			try {
				for (var k in handlers) {
					// noinspection JSUnfilteredForInLoop
					handlers[k](message);
				}
			} catch (e) {
				notifyProgrammingError("error while calling messageHandlers for message type " + message.messageType +
						": " + e, e);
			}
		} else {
			logWarn("no handler for message with type " + message.messageType);
		}
	}

	/**
	 * send message to the server
	 * if the connection is not yet established and the client is not authenticated,
	 * _some_ message types are stored and sent later, while others are dropped
	 *
	 * @param message (object)
	 * @param type (string) optional, if omitted, message.messageType is used
	 */
	function sendMessage(message, type) {
		if (!type) {
			if (message.messageType) {
				type = message.messageType;
			} else {
				notifyProgrammingError("communication.sendMessage() called without message Type");
				return;
			}
		}

		// do some legacy adjustment: The TedContribution was renamed to VoteContribution in V6 .... #60640
		if (type === "TedContribution") {
			type = "VoteContribution";
		}

		// The structure of FormContributions is no longer adapted on the server, so the client must ensure the correct format
		// add legacy support here, as there are a LOT of places where FormContributions are used #65728
		// if a "values" attribute is already present, skip this step
		if (type === "FormContribution" && !message.values) {
			var values = message;
			// create a new message object
			message = {
				values: values
			};
			// copy all attributes from the values
			// todo: channelDescriptior is only needed in QuestionContributions & their messages -> remove here
			var attributes = ["oid", "channelDescriptor", "formId", "hidden", "answerTime"];
			for (var i in attributes) {
				var attribute = attributes[i];
				if (values[attribute]) {
					message[attribute] = values[attribute];
					delete values[attribute];
				}
			}
		}

		message.messageType = type;
		if (!connection) {
			// todo it would be better to already queue this message here, i.e. move OutBuffer to Communication
			return log.error("Cannot sendMessage of type ", type, " - connection is null");
		}
		connection.sendMessage(message);
	}

	function sendCommunicationErrorInfoMessage(userMessage, e, messageId, messageString) {
		var msg = userMessage + " - " + e.message + " - #" + messageId + ": " + messageString;
		log.error(msg, e);
		sendMessage({
			            messageType: "InfoMessage",
			            infoCode: 0,
			            infoLevel: communication.LEVEL_ERROR,
			            message: msg
		            });
	}

	/**
	 * registers a messageHandler function for a given messageType
	 * @param messageType
	 * @param handler
	 */
	function registerMessageHandler(messageType, handler) {
		if (!messageType || typeof handler !== "function") {
			notifyProgrammingError("registerMessageHandler called without messageType or handler function passed");
			return;
		}
		log.debug('communication registered handler for messageType ', messageType);
		if (!messageHandlers[messageType]) {
			messageHandlers[messageType] = [];
		}
		messageHandlers[messageType].push(handler)
	}

	/**
	 * register several message handlers with one call
	 * @param handlersMap { "MessagType": [list, of, handler, functions], ... }
	 */
	function registerMessageHandlers(handlersMap) {
		for (var messageType in handlersMap) {
			var handlers = handlersMap[messageType];
			for (var i in handlers) {
				registerMessageHandler(messageType, handlers[i]);
			}
		}
	}

	/**
	 * Register new message types (defined by plugins & modules) that should not be stored in the
	 * PersistentMessageQueue
	 *
	 * @param messageType
	 */
	function registerNonPersistentMessageType(messageType) {
		nonPersistentMessages[messageType] = true;
	}

	/**
	 * register an array of messages types as non persistent messages
	 * @param messageTypes
	 */
	function registerNonPersistentMessageTypes(messageTypes) {
		for (var i in messageTypes) {
			registerNonPersistentMessageType(messageTypes[i]);
		}
	}

	/**
	 * checks if this message type should be stored in the PersistentMessageQueue (returns true)
	 * or not for message types which does not make any sense to be stored as they become irrelevant (returns false)
	 *
	 * @param messageType
	 * @returns {boolean}
	 */
	function isPersistentMessageType(messageType) {
		return nonPersistentMessages[messageType] !== true;
	}

	/**
	 * checks if this message type is allowed to send out before the client is authenticated
	 * if not yet authenticated, the connection will store the message in the PersistentMessageQueue to be sent later
	 *
	 * @param messageType
	 * @returns {boolean}
	 */
	function isPreAuthenticationAllowedMessageType(messageType) {
		return preAuthenticationAllowedMessages[messageType] === true;
	}

	/**
	 * Sets the status of the server connection
	 * @param status 0 - OK, 1 - Warning, 2 - Error
	 */
	function setNetworkStatus(/*Integer */status) {
		// pending is the actually needed? Might be helpful for debugging ...
		connection.setNetworkStatus(status); // forward to connection
	}

	function getStatus() {
		return {
			messageHandlers: messageHandlers,
			persistentContributionQueue: persistentContributionQueue,
			preAuthenticationAllowedMessages: preAuthenticationAllowedMessages,
			nonPersistentMessages: nonPersistentMessages,
			connection: connection.getStatus(),
			self: self
		};
	}
}

if (typeof module === "object") {
	module.exports = ServerCommunication;
}
